import gql from 'graphql-tag';

export const CREATE_TEMPLATE = gql`
  mutation createNotificationTemplate(
    $input: CreateNotificationTemplateInput!
  ) {
    createNotificationTemplate(input: $input) {
      id
      templateName
      code
      channel
      subject
      body
      isActive
      placeholders
      status
    }
  }
`;

export const UPDATE_TEMPLATE = gql`
  mutation updateNotificationTemplate(
    $id: Int!
    $input: UpdateNotificationTemplateInput!
  ) {
    updateNotificationTemplate(
      id: $id
      input: $input
    ) {
      id
      templateName
    }
  }
`;

export const REMOVE_SERVICE_TASK = gql`
  mutation removeServiceTask($id: Int!) {
    removeServiceTask(id: $id)
  }
`;
export const REMOVE_SERVICE_TASK_ASSIGNMENT = gql`
  mutation removeServiceTaskAssignment($id: Int!) {
    removeServiceTaskAssignment(id: $id)
  }
`;

export const REMOVE_TEMPLATE = gql`
  mutation removeNotificationTemplate($id: Int!) {
    removeNotificationTemplate(id: $id)
  }
`;
